import styled from 'styled-components';

export const Loader = styled.div`
  width: 100%;
  height: 100%;
  text-align: center;
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

export const Spin = styled.div`
  margin: auto;
  border: 10px solid #f1b0c9;
  border-radius: 50%;
  border-top: 10px solid #ff005c;
  width: 70px;
  height: 70px;
  animation: spinner 4s linear infinite;
  @keyframes spinner {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
`;
